import { render, staticRenderFns } from "./CreateUserDialog.vue?vue&type=template&id=b6a5df3c&"
import script from "./CreateUserDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports